import type { ReactElement } from 'react'
import { Link } from 'react-router'
import SectionHeader from '../components/SectionHeader'
import { useT } from '../i18n/useI18n'

export default function Partners(): ReactElement {
  const t = useT()

  return (
    <section className="section">
      <div className="container">
        <SectionHeader title={t('partners.heading')} subtitle={t('partners.subheading')} />
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="feature-box text-center">
              <div className="feature-icon mx-auto">
                <i className="bi bi-people"></i>
              </div>
              <h3>{t('partners.comingSoon')}</h3>
              <p className="description">{t('partners.placeholder')}</p>
              <div className="feature-cta">
                <Link to="/contact" className="btn btn-primary">
                  <i className="bi bi-envelope me-2"></i>
                  {t('partners.cta')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
